import styles from './SocialMediaFooter.module.scss'
import { FacebookIcon, TwitterIcon } from 'react-share'

const SocialMediaFooter = () => {
  return (
    <div className={`${styles.SocialMediaFooter} px-5 sm:px-0`}>
      <div className={styles.Title}>
        Preuzmite Dnevno.me mobilnu aplikaciju na
      </div>
      <div className={styles.StoreButtonContainer}>
        <a
          href="https://play.google.com/store/apps/details?id=com.dnevne.dnevne"
          target="_blank"
          rel="noreferrer"
        >
          <img className={styles.StoreButton} src="/playstore.png" />
        </a>
        <a
          href="https://apps.apple.com/us/app/dnevno-me/id1584247258"
          target="_blank"
          rel="noreferrer"
        >
          <img className={styles.StoreButton} src="/appstore.png" />
        </a>
      </div>

      <div className={styles.SocialMediaContainer}>
        <div className={styles.SocialMediaTitle}>Pratite nas na</div>
        <div className={styles.SocialMediaButtons}>
          <div className={styles.SocialMediaButton}>
            <a
              href="https://www.facebook.com/portaldnevno"
              target="_blank"
              rel="noreferrer"
            >
              <FacebookIcon size={40} round={true} />
            </a>
          </div>
          <div className={styles.SocialMediaButton}>
            <a
              href="https://twitter.com/DnevnoPortal"
              target="_blank"
              rel="noreferrer"
            >
              <TwitterIcon size={40} round={true} />
            </a>
          </div>
          <div className={styles.SocialMediaButton}>
            <a
              href="https://www.instagram.com/dnevno.me"
              target="_blank"
              rel="noreferrer"
            >
              <img src="/instagram-circle.svg" />
            </a>
          </div>
        </div>
      </div>
      <div className={styles.SocialMediaContainer}>
        <div className={styles.SocialMediaTitle}>
          Pridružite se našoj Viber zajednici
        </div>
        <div className={`${styles.SocialMediaButtons} ${styles.Large}`}>
          <div className={`${styles.SocialMediaButton} ${styles.Large}`}>
            <a
              href="https://invite.viber.com/?g2=AQA7cytqD78wbU8GbecFlnDLDAOx1GXjEhhKPdfPrHhf5kXRHuBUYL9gEtKAX6Cg"
              target="_blank"
              rel="noreferrer"
            >
              <img src="/viber.png" />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SocialMediaFooter
